import { render, staticRenderFns } from "./acatelogin.vue?vue&type=template&id=73d98c21&"
import script from "./acatelogin.vue?vue&type=script&lang=js&"
export * from "./acatelogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports